'use client';

import { useLocales } from '@/locales';
import { Button, Stack, Typography } from '@mui/material';
import { useRouter } from 'next/navigation';
export default function ExpireLinkNotFound() {
  const { t } = useLocales();
  const router = useRouter();

  const onClick = () => {
    router.push('/auth/sign-in');
  };

  return (
    <Stack
      gap={6}
      alignItems={'center'}
      justifyContent={'center'}
      justifyItems={'center'}
      height={'100vh'}
    >
      <Typography
        sx={{
          fontSize: {
            xs: '30px',
            md: '40px',
          },
          fontWeight: 'bold',
          textAlign: 'center',
          whiteSpace: 'break-spaces',
        }}
        color={'primary.main'}
      >
        {t('page.notFound.title')}
      </Typography>
      <Typography
        sx={{
          textAlign: 'center',
          fontSize: '16px',
          whiteSpace: 'break-spaces',
        }}
      >
        {t('page.notFound.description')}
      </Typography>

      <Button
        variant="contained"
        color="primary"
        size="large"
        onClick={onClick}
      >
        {t('page.notFound.loginButton.title')}
      </Button>
    </Stack>
  );
}
